import React from 'react';
import { StyleProps } from '$/components/ui';
import {
  AttendeeFragment,
  InteractionForAttendeeFragment,
  InteractionFragment,
  PublicEWebinarFragment,
} from '$/GraphQL/schema/types';

import { RenderColumnData } from '$/sections/Home/Dashboard/Registrants/types';
import { InteractionInfo, NoBodyCard } from './InteractionInfo';
import { PageMode } from '$/widget/src/interface';
import { theme } from 'twin.macro';

import { TimelineComponents } from '$/components/WebinarPlayer/context';

import { FlagIcon } from '$/images/FontAwesomeIcons';
import { useCardContext } from './cards/CardContext';
import { StartOrEndMarker } from './cards/StartOrEndMarker';
import { AnalyticsCardProps } from './cards/types';
import { InteractionModalAccordionsHook, InteractionModalComponentProps } from './types';

const TipModalCard = React.lazy(() => import('./Tip/TipModal'));
const AnalyticsClickCard = React.lazy(() => import('./cards/AnalyticsClickCard'));

const StreamInfoCard: React.FC = () => {
  const { interaction } = useCardContext();

  return (
    <StartOrEndMarker
      text={interaction.title()}
      color={theme`colors.black`.toString()}
      mode={PageMode.edit}
    />
  );
};

export class StreamInfo extends InteractionInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public typeName(): string | undefined {
    return this.title();
  }

  public userCanAdd(): boolean {
    return false;
  }

  public timelineComponent(): keyof TimelineComponents {
    return 'anchor';
  }

  public category(): 'Standard' | 'Special' | 'Anchor' | 'Conversion' {
    return 'Anchor';
  }

  public hasExpiresInField(): boolean {
    return false;
  }

  public supportsShortcut(): boolean {
    return false;
  }

  public onlyOneInstance(): boolean {
    return true;
  }

  public isInteractiveCard(): boolean {
    return false;
  }

  public hasEndsAt(): boolean {
    return false;
  }

  public isVisibleToAttendee(): boolean {
    return false;
  }

  public icon(): React.FC<StyleProps> {
    return FlagIcon;
  }

  public hasCard(_isPreview?: boolean): boolean {
    return false;
  }

  public isEditable(): boolean {
    return false;
  }

  public hasAnswers(): boolean {
    return false;
  }

  // Wants to show results
  public hasResultsToShow(): boolean {
    return false;
  }

  public renderColumnData(_data: RenderColumnData): RenderColumnData | null {
    return null;
  }

  public onlyExistsInPresentationRoom(): boolean {
    return true;
  }

  public cardComponent(): React.FC<{ onClickHeader?: () => void }> {
    return StreamInfoCard;
  }

  public cardBodyComponent(): React.FC {
    return NoBodyCard;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsClickCard;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return TipModalCard;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook | null {
    return null;
  }
}
